/*----------  Global Variables  ----------*/

let wWidth;
let wHeight;

/*----------  Document Ready  ----------*/

$(document).ready(() => {
	wWidth = $(window).width();
	wHeight = $(window).height();

	// Defaults
	Validate.defaults();
	TWBS_Modal.defaults();

	// Components
	Toggle.init();
	Select.init();
	TinyMce.init();
	DateRange.init();
	JqDatepicker.init();
	JqDatemask.init();
	Scrollbar.init();
	Popups.init();

	console.log('Ready!');
});

/*----------  Window Events  ----------*/

$(window).on('load resize', () => {
	wWidth = $(window).width();
	wHeight = $(window).height();
});

$(window).on('load', () => {
	wWidth = $(window).width();
	wHeight = $(window).height();

	// Header
	Header().initMiniSidebar();

	if(wWidth < 768) {
		Header().initSubMenu();
		Header().initMainMenuToggle();
	}
});
